import React, { Component } from 'react';

class ModeColorIndex extends Component {
  constructor(props) {
    super(props)
    this.state = {

    }
  }

  render() {
    return (
      <div className="container_swith_theme">
        {/* <div className="container_25_width">
          <p className="container_swith_theme_text">Dark</p>
        </div>
        <div className="container_50_width">
          <div className='ToggleSwitch ToggleSwitch__rounded'>
            <div className='ToggleSwitch__wrapper'>
              <div className={`Slider ${this.props.checked && 'isChecked'}`} onClick={() => { this.props.onToggleSwitchChange() }}></div>
            </div>
          </div>
        </div>
        <div className="container_25_width">
          <p className="container_swith_theme_text">Light</p>
        </div> */}
      </div>
    );
  }
} export default ModeColorIndex;